import { render, staticRenderFns } from "./fenhong.vue?vue&type=template&id=e1d873e4"
import script from "./fenhong.vue?vue&type=script&lang=js"
export * from "./fenhong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports